import {Box, Group} from '@mantine/core';
import type {FC, ReactNode} from 'react';

/**
 * Space-between row for a content group on the left and an action node on
 * the right.
 * @registry Header-style row: content group left, action(s) right.
 *
 * Ported from `library-m/layout/ContentRow`. Prop surface kept identical.
 */
export interface ContentRowProps {
  actionNode?: ReactNode;
  children?: ReactNode;
}

export const ContentRow: FC<ContentRowProps> = ({children, actionNode}) => {
  return (
    <Group mb="md" justify="space-between">
      <Group>{children}</Group>
      <Box>{actionNode}</Box>
    </Group>
  );
};
